import { useState } from "react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { toast } from "sonner";

// target: null = closed, {self: true} = own password, {id, name} = reset other user
export const PasswordDialog = ({ target, onClose, onSubmit }) => {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);
  const isSelf = target?.self;

  const close = () => {
    setCurrent(""); setNext(""); setConfirm("");
    onClose();
  };

  const submit = async () => {
    if (next.length < 6) return toast.error("A nova senha deve ter pelo menos 6 caracteres");
    if (next !== confirm) return toast.error("As senhas não conferem");
    if (isSelf && !current) return toast.error("Informe a senha atual");
    setSaving(true);
    try {
      await onSubmit({ current, next });
      toast.success(isSelf ? "Senha alterada com sucesso!" : `Senha de ${target.name} redefinida!`);
      close();
    } catch (error) {
      const d = error.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Erro ao salvar senha");
    } finally {
      setSaving(false);
    }
  };

  const field = (label, value, set, testid) => (
    <div className="space-y-2">
      <Label className="text-slate-300">{label}</Label>
      <Input type="password" value={value} onChange={(e) => set(e.target.value)}
        className="bg-slate-800 border-slate-700 text-white" data-testid={testid} />
    </div>
  );

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && close()}>
      <DialogContent className="bg-slate-900 border-slate-800" data-testid="password-dialog">
        <DialogHeader>
          <DialogTitle className="text-white">{isSelf ? "Alterar minha senha" : `Redefinir senha de ${target?.name}`}</DialogTitle>
          <DialogDescription className="text-slate-400">Mínimo de 6 caracteres</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          {isSelf && field("Senha atual", current, setCurrent, "current-password-input")}
          {field("Nova senha", next, setNext, "new-password-input")}
          {field("Confirmar nova senha", confirm, setConfirm, "confirm-password-input")}
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={close} className="border-slate-700 text-slate-300 hover:bg-slate-800">Cancelar</Button>
          <Button onClick={submit} disabled={saving} className="bg-[#FF4500] hover:bg-[#CC3700] text-white" data-testid="save-password-button">
            {saving ? "Salvando..." : "Salvar senha"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
